import * as React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import { Button, Carousel } from "react-bootstrap";

import "./styles/slider.scss";

const Slider = (props) => {
  return (
    <div id="portfolio" className="slider">
      <Carousel touch="true">
        {props.data.nodes.map(({ id, title, excerpt, featuredImage, uri }) => (
          <Carousel.Item key={id}>
            <div className="overlay" />
            <GatsbyImage
              className="image"
              image={
                featuredImage.node.localFile.childImageSharp.gatsbyImageData
              }
              alt="test"
            />
            <Carousel.Caption className="fade-in-slow">
              <h2 className="shout">{title}</h2>
              <div dangerouslySetInnerHTML={{ __html: excerpt }} />
              <Link to={`${uri}`}>
                <Button variant="secondary">View Project</Button>
              </Link>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default Slider;
